document.addEventListener("DOMContentLoaded", () => {
    var airSwiper = new Swiper(".air-components-content", {
        slidesPerView: 3,
        spaceBetween: 25,
        keyboard: { enabled: true },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        breakpoints: {
            769: {
                slidesPerView: 3,
                spaceBetween: 25,
            },
            501: {
                slidesPerView: 2,
                spaceBetween: 25,
            },
            300: {
                slidesPerView: 1.15,
                spaceBetween: 20,
            },
        }
    });
});